import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import InputAdornment from '@mui/material/InputAdornment';
import AssignmentIndTwoToneIcon from '@mui/icons-material/AssignmentIndTwoTone';
import Button from '@mui/material/Button';

import Swal from 'sweetalert2'
import './Login.css'
import { Link, useNavigate } from 'react-router-dom';
import { login, fetchOtp, matchOtpService, registerUser } from '../components/ApiService'
import { CircularProgress } from '@mui/material';

const Registration = () => {
    const [firstName, setfirstName] = useState("")
    const [lastName, setlastName] = useState("")
    const [contact, setContact] = useState('')
    // const [otp, setOtp] = useState("")
    const [showOtp, setshowOtp] = useState(false)
    const [message, setMessage] = useState('');
    const [showRequestOtpBtn, setshowRequestOtpBtn] = useState(true)
    const [openProgressLoader, setopenProgressLoader] = useState(false)
    const [timeLeft, setTimeLeft] = useState(0);
    const [isRunning, setIsRunning] = React.useState(false)
    const [matchOtp, setMatchOtp] = useState('')

    const navigate = useNavigate()

    useEffect(() => {
        let timer;
        if (isRunning && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft((time) => time - 1)
            }, 1000)
        } else if (timeLeft === 0) {
            setIsRunning(false)
        }
        return () => clearInterval(timer)
    }, [isRunning, timeLeft])

    // TIMER 
    const startTimer = () => {
        if (!isRunning) {
            setTimeLeft(30);
            setIsRunning(true)
        }
    }

    const getFirstName = (e) => {
        setfirstName(e.target.value)
    }

    const getLastName = (e) => {
        setlastName(e.target.value)
    }

    const getContact = (event) => {
        const value = event.target.value
        if (/^\d*$/.test(value)) {
            setContact(value)
            const regex = /^\d{10}$/;
            if (value.length === 0 || regex.test(value)) {
                setMessage(value.length === 10 ? 'Mobile number is valid.' : '');

            } else {
                setMessage('Mobile number must be exactly 10 digits.');
            }
        } else {
            setMessage('Only digits are allowed.');
        }
    }

    const getOtp = () => {
        setopenProgressLoader(true)
        const pattern = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/;
        // console.log(contact, "contact no")
        // CALL TIMER FUNCTION
        startTimer()

        setshowRequestOtpBtn(false)
        setshowOtp(true)
        setMessage('')

        const obj = {
            "phoneCountryCode": "+91",
            "phoneNumber": contact
        }

        fetchOtp(obj).then((res) => {
            console.log(res, "OTP")
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "success",
                title: res.data.message
            });
            setTimeout(() => {
                setopenProgressLoader(false)
            }, 1500);
        }).catch((error) => {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: error.data.message
            });
            setTimeout(() => {
                setopenProgressLoader(false)
            }, 1500);
        }).finally(() => {
            setopenProgressLoader(false)
        })
    }

    const register = () => {
        startTimer()
        setopenProgressLoader(true)
        const pattern = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/;
        const obj = {
            "firstName": firstName,
            "lastName": lastName,
            "phoneCountryCode": "+91",
            "phoneNumber": contact,
        }
        if (firstName == "" && lastName == "") {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: "First & Last Name is mandatory!"
            });
            setTimeout(() => {
                setopenProgressLoader(false)
            }, 1500);
        } else if (contact == "" || contact.length != 10) {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: "Contact number must be of 10 digits"
            });
            setTimeout(() => {
                setopenProgressLoader(false)
            }, 1500);
        } else if (!contact.match(pattern)) {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: "Enter Valid Contact number"
            });
            setopenProgressLoader(false)
            setContact("")
            setMessage('')
        } else {
            registerUser(obj).then((res) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                Toast.fire({
                    icon: "success",
                    title: res.data.message
                });
                // console.log(res, "REGISTER")
                setTimeout(() => {
                    setopenProgressLoader(false)
                }, 1500);

                setshowRequestOtpBtn(false)
                setshowOtp(true)
                setMessage('')
            }).catch((error) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                Toast.fire({
                    icon: "error",
                    title: error.response.data.message
                });
                // console.log(error, "REGISTER ERR")
                setTimeout(() => {
                    setopenProgressLoader(false)
                }, 1500);
                setshowOtp(false)
                setshowRequestOtpBtn(true)
                setMessage('')
            })
        }
    }

    const submitLogin = () => {
        setopenProgressLoader(true)
        const obj = {
            "phoneCountryCode": "+91",
            "phoneNumber": contact,
            "phoneOtp": matchOtp
        }

        if ((firstName == "" && lastName == "") && (contact == "" || contact.length != 10) && matchOtp == '') {
            const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: "All fields are mandatory!"
            });
            setTimeout(() => {
                setopenProgressLoader(false)
            }, 1500);
        } else {
            matchOtpService(obj).then((res) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                Toast.fire({
                    icon: "success",
                    title: res.data.message
                });
                setTimeout(() => {
                    setopenProgressLoader(false)
                }, 1500);
                var storeUserToken = res.data.token;
                var storeUserInfo = res.data.user

                // console.log(storeUserToken, "storeUserToken")
                // console.log(storeUserInfo, "storeUserInfo")
                let itemsObj = {
                    "token" : storeUserToken,
                    "userDetails" : storeUserInfo
                }
                localStorage.setItem("user", JSON.stringify(itemsObj))
                navigate("/")
            }).catch((error) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                Toast.fire({
                    icon: "error",
                    title: error?.response?.data.message
                });
                setTimeout(() => {
                    setopenProgressLoader(false)
                }, 1500);
            })
        }
    }


    return (
        <>
            {/* LOADER */}
            {openProgressLoader ?
                <div className='progressCont'>
                    <CircularProgress size='5rem' color='secondary' className='loadCnt' />
                </div>
                : ""
            }

            <section className='registrationCont'>
                <div className='registerBox'>
                    <div className='registerLeft'>
                        <img src="images/logo.png" className='img-fluid' alt='car-genie' />
                    </div>
                    <form className='registerForm'>
                        <h4> Sign Up to get started! </h4>
                        <Box autoComplete="off" className="registerCont">
                            <TextField
                                id="outlined-basic1"
                                margin="normal"
                                color="secondary"
                                label="First Name"
                                variant="outlined"
                                onChange={getFirstName}
                                slotProps={{
                                    input: {
                                        startAdornment: <InputAdornment position="start">
                                            <AssignmentIndTwoToneIcon color="action" />
                                        </InputAdornment>,
                                    },
                                }}
                            />

                            <TextField
                                id="outlined-basic1"
                                margin="normal"
                                color="secondary"
                                label="Last Name"
                                variant="outlined"
                                onChange={getLastName}
                                slotProps={{
                                    input: {
                                        startAdornment: <InputAdornment position="start">
                                            <AssignmentIndTwoToneIcon color="action" />
                                        </InputAdornment>,
                                    },
                                }}
                            />

                            {/* CONTACT NUMBER */}
                            <TextField
                                label="Contact Number"
                                margin="normal"
                                id="outlined-start-adornment2"
                                type='tel'
                                color="secondary"
                                maxLength="10"
                                value={contact}
                                required
                                // pattern="\d{3}[\-]\d{3}[\-]\d{4}"
                                // sx={{ m: 1, width: '25ch' }}
                                onChange={getContact}
                                slotProps={{
                                    input: {
                                        startAdornment: <InputAdornment position="start">+91</InputAdornment>,
                                    },
                                }}
                            />
                            {message && (
                                <p style={{ color: message === 'Mobile number is valid.' ? 'green' : 'red' }}>
                                    {message}
                                </p>
                            )}

                            {showRequestOtpBtn ?
                                <Button variant="contained" style={{ marginTop: '10px' }} onClick={register}>Request OTP</Button>
                                : ""}

                            {showOtp ?
                                <>
                                    <TextField
                                        label="OTP"
                                        margin="normal"
                                        id="outlined-start-adornment3"
                                        color="secondary"
                                        onChange={(e) => setMatchOtp(e.target.value)}
                                        required
                                        slotProps={{
                                            input: {
                                                startAdornment: <InputAdornment>
                                                    <LockOpenTwoToneIcon color="action" />
                                                </InputAdornment>,
                                            },
                                        }}
                                    />

                                    <div className='otpTimerCont'>
                                        {isRunning ?
                                            <p style={{ marginBottom: '0', marginRight: '20px' }}>Resend OTP will enable in {timeLeft} secs! </p>
                                            : ""}
                                        <Button variant="contained" style={{ marginTop: '10px' }} onClick={getOtp} disabled={isRunning}>Resend OTP</Button>
                                    </div>
                                </>
                                : ""}

                            {showOtp ?
                                <Button variant="contained" style={{ marginTop: '10px' }} onClick={submitLogin}>Proceed</Button>
                                :
                                ""
                            }

                            <p style={{ marginTop: '10px' }}>Already have an account?
                                <Link to="/login"> Log In</Link>
                            </p>
                        </Box>
                    </form>
                </div>
            </section>
        </>
    )
}

export default Registration